import { render, staticRenderFns } from "./ForgotEmail.vue?vue&type=template&id=296f18d4&scoped=true"
import script from "./ForgotEmail.vue?vue&type=script&lang=js"
export * from "./ForgotEmail.vue?vue&type=script&lang=js"
import style0 from "./ForgotEmail.vue?vue&type=style&index=0&id=296f18d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296f18d4",
  null
  
)

export default component.exports